import { CloudFog, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { SmokeScene } from "@/components/SmokeScene";
import { btnPrimary } from "@/lib/ui";

export const SmokeBanner = () => (
  <section className="relative overflow-hidden border-y border-[#FF8A00]/15 bg-[#10232F] py-16 md:py-20" data-testid="smoke-banner">
    <div
      className="pointer-events-none absolute -left-20 top-0 h-full w-2/3 opacity-25"
      style={{ background: "radial-gradient(ellipse at left center, rgba(203,211,217,0.35), transparent 65%)" }}
      aria-hidden="true"
    />
    <div className="scan-line" aria-hidden="true" />
    <div className="relative mx-auto grid max-w-7xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:px-10">
      <div>
        <Reveal>
          <div className="flex items-center gap-3">
            <span className="flex h-11 w-11 items-center justify-center rounded-xl border border-[#FF8A00]/40 bg-[#090D10] text-[#FF8A00]">
              <CloudFog size={20} strokeWidth={1.5} />
            </span>
            <p className="font-heading text-xs font-semibold uppercase tracking-[0.3em] text-[#FF8A00]">
              Extra vroege waarschuwingslaag
            </p>
          </div>
          <h2 className="mt-5 font-heading text-base font-bold tracking-tight text-[#F5F7F9] sm:text-2xl md:text-3xl">
            Detecteert ook rook — vaak nog vóórdat hitte of vuur ontstaat
          </h2>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-[#CBD3D9] md:text-base">
            Onze camerasystemen kunnen rookontwikkeling al in een vroeg stadium detecteren, vaak nog
            voordat er duidelijke hitte, vlammen of een meetbare temperatuurstijging ontstaat. Samen
            met de thermische bewaking ontstaat zo een dubbele vroege signalering: rook én warmte.
          </p>
          <p className="mt-3 text-xs leading-relaxed text-[#CBD3D9]/60">
            De beschikbaarheid en prestaties van rookdetectie zijn afhankelijk van het cameramodel, de
            zichtlijn, verlichting en configuratie.
          </p>
          <Link to="/offerte" className={`${btnPrimary} mt-8`} data-testid="smoke-banner-cta">
            Vraag advies aan <ArrowRight size={16} />
          </Link>
        </Reveal>
      </div>
      <Reveal delay={0.15}>
        <SmokeScene />
      </Reveal>
    </div>
  </section>
);
